import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header/Header";

const AuthLayout = () => (
  <>
    <Header />
    <Outlet />
  </>
);

export default AuthLayout;
